import { ICellRendererParams } from "@ag-grid-community/core";
import { GenericTableCell } from "gen/model/genericTableCell";
import { GenericTableRow } from "gen/model/genericTableRow";
import React from "react";
import { useTranslation } from "react-i18next";
import { DataTableContext } from "shared/components/table/data/DataTableContext";
import { DataTableCellContentRenderer } from "shared/components/table/data/internal/DataTableCellContentRenderer";
import { useBuildDataTableColumnContext } from "shared/components/table/data/internal/DataTableContextBuilders";
import { getAllLeafChildrenAfterFilter } from "shared/components/table/data/internal/DataTableInternalUtils";

export const DataTableCellRenderer: React.FC<
  ICellRendererParams<GenericTableRow, GenericTableCell, DataTableContext>
> = (props) => {
  const { t } = useTranslation(["common"]);

  const tableContext: DataTableContext = props.context;
  const columnContext = useBuildDataTableColumnContext(
    tableContext,
    props.column!,
  );

  const cell = props.value;
  if (cell) {
    return (
      <DataTableCellContentRenderer
        tableContext={tableContext}
        columnContext={columnContext}
        row={props.node}
        cell={cell}
        params={props}
      />
    );
  }

  const children = getAllLeafChildrenAfterFilter(props.node);
  if (children?.length) {
    const hasEditableChildren = children.some(
      (row) => row.data?.cells[columnContext.columnId]?.form_field,
    );
    const hasChildValue = children.some((node) =>
      Boolean(node.data?.cells[columnContext.columnId]),
    );
    if (hasChildValue && !hasEditableChildren) {
      return (
        <div className="mb-dt-cell-content mb-dt-cell-varies">
          {t("common:table.varies")}
        </div>
      );
    }
  }

  const isNumericColumn =
    columnContext.inferredData?.valueType &&
    ["money", "decimal", "percent"].includes(
      columnContext.inferredData.valueType,
    );
  if (isNumericColumn) {
    return "-";
  }

  return null;
};
